// @flow
import * as React from 'react';
import cx from 'classnames';

import styles from './ContentContainer.module.scss';

type ContentContainerProps = {
  width: 'narrow' | 'normal' | 'wide',
};

const ContentContainer: React.ComponentType<ContentContainerProps> = ({
  width = 'normal',
  children,
}) => <div className={cx(styles.base, styles[`base_width_${width}`])}>{children}</div>;

export default ContentContainer;
